import { STORAGE_LOCK_CHANGE } from '../actions/change';

const initialState = {
    status: 'unlocked',
    date: undefined,
    debt: undefined,
};

export default function storageLock(state, { type, data }) {
    if (!state) {
        return initialState;
    }

    // eslint-disable-next-line
    switch (type) {
        case STORAGE_LOCK_CHANGE: {
            const { status, date, debt } = data;

            return {
                status,
                date,
                debt,
            };
        }

        default:
            return state;
    }
}
